import { render, staticRenderFns } from "./LglRequirement.vue?vue&type=template&id=543704be&"
import script from "./LglRequirement.vue?vue&type=script&lang=js&"
export * from "./LglRequirement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports